module.exports = __webpack_public_path__ + "static/media/yash.bcd8badd.png";